import { configureStore } from '@reduxjs/toolkit';
import sideMenuReducer from './sideMenuSlice';
import themeReducer from './themeSlice';
import compactMenuReducer from './compactMenuSlice';
import pageLoaderReducer from './pageLoaderSlice';

export const store = configureStore({
  reducer: {
    sideMenu: sideMenuReducer,
    theme: themeReducer,
    compactMenu: compactMenuReducer,
    pageLoader: pageLoaderReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
